import { render, staticRenderFns } from "./PaperPurchase.vue?vue&type=template&id=2dfcbc2a&scoped=true"
import script from "./PaperPurchase.vue?vue&type=script&lang=js"
export * from "./PaperPurchase.vue?vue&type=script&lang=js"
import style0 from "./PaperPurchase.vue?vue&type=style&index=0&id=2dfcbc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcbc2a",
  null
  
)

export default component.exports